import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { Logo } from "../components/Logo";

export default function ImpressumPage() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white">
      <header className="px-4 md:px-8 py-6 border-b border-slate-100">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors" data-testid="impressum-back-btn">
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück</span>
          </button>
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
            <Logo size="md" clickable={false} />
          </div>
          <div className="w-20" />
        </div>
      </header>

      <main className="px-4 md:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto prose prose-slate" data-testid="impressum-content">
          <h1 className="text-3xl font-bold text-slate-900 mb-8">Impressum</h1>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-slate-900 mb-2">Angaben gemäß § 5 DDG</h2>
            <p className="text-slate-600 leading-relaxed">
              WebGenerator<br />
              Inhaber: Elmedin Haskic<br />
              Herderstr. 6<br />
              85435 Erding<br />
              Deutschland
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-slate-900 mb-2">Kontakt</h2>
            <p className="text-slate-600 leading-relaxed">
              E-Mail: support@webgenerator.de
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-slate-900 mb-2">Umsatzsteuer-ID</h2>
            <p className="text-slate-600 leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              BITTE ANGEBEN (falls vorhanden)
            </p>
          </section>


          <section className="mb-8">
            <h2 className="text-lg font-bold text-slate-900 mb-2">Haftungsausschluss</h2>
            <h3 className="text-base font-semibold text-slate-800 mb-1">Haftung für Inhalte</h3>
            <p className="text-slate-600 leading-relaxed mb-4">
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <h3 className="text-base font-semibold text-slate-800 mb-1">Haftung für Links</h3>
            <p className="text-slate-600 leading-relaxed mb-4">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-slate-900 mb-2">Urheberrecht</h2>
            <p className="text-slate-600 leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
          </section>

        </div>
      </main>
    </div>
  );
}
